<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page row-start">
        <div class="form-item-rangedata"><RangeDataSelect :periodoInicial="'currentYear'" v-model="dateRange"/></div>
        <div class="form-item"><EstabelecimentoSelect v-model:idSelecionado="estabelecimentoSelecionado" /></div>
        <button type="button" class="buttom-icon--printer" @click="openReport" />
        <button type="button" class="buttom-icon--close" @click="closePage" />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { Funcoes } from '@/funcoes/funcoes';
import { genericReport } from '@/funcoes/api';
import { globalStore } from '@/globals';
import EstabelecimentoSelect from '../selects/EstabelecimentoSelect.vue';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import RangeDataSelect from '../selects/RangeDataSelect.vue';

const emit = defineEmits(['close']);
const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const estabelecimentoSelecionado = ref(null);
const msgAlerta = ref(null);
const isLoading = ref(false);

const closePage = () => {emit('close');}

const openReport = async() => {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        if (!estabelecimentoSelecionado.value) throw new Error('Necessário informar o estabelecimento');
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            nmrelatorio: 'mapa_estatistico',
            idep: globalStore.idep,
            idusuario: globalStore.idusuario,
            idestabelecimento: estabelecimentoSelecionado.value,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate
        };
        const response = await genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}
</script>